<section *ngIf="showPagination()">
  <ul id="pagination-wrapper-container">
    <!-- Previous -->
    <li class="pagination-item" [class.disabled]="onFirstPage() || !hasPages()">
      <a class="pagination-link" (click)="clickPageNo(getPagePrevious())">
        <mat-icon class="material-icons-sharp">keyboard_arrow_left</mat-icon>
      </a>
    </li>

    <!-- Page Index -->
    <li
      class="pagination-item"
      *ngFor="let page of getPageIndicies(); let i = index"
      [ngClass]="{ active: onPageIndex(i), disabled: showDots(i) }"
    >
      <a class="pagination-link" *ngIf="showDots(i)">...</a>
      <a class="pagination-link" *ngIf="!hidePageIndex(i)" (click)="clickPageNo(i + 1)">{{ i + 1 }}</a>
    </li>
    <!-- Next -->
    <li class="pagination-item" [class.disabled]="onLastPage() || !hasPages()">
      <a class="pagination-link" (click)="clickPageNo(getPageNext())">
        <mat-icon class="material-icons-sharp">keyboard_arrow_right</mat-icon>
      </a>
    </li>
  </ul>
</section>
